export default "__VITE_PUBLIC_ASSET__d443488b__"